<template>
  <div
    id="slider"
    class="overflow-hidden relative"
    :aria-label="$t('pages.visitImage.otherMetada')"
  >
    <transition-group
      tag="span"
      :name="transitionName"
      class="slides-group"
    >
      <div
        :key="'current'+current"
        class="scroll-container"
      >
        <dl
          v-if="show"
          :key="current"
          class="relative"
        >
          <template
            v-for="(meta, i) in metadataFiltered"
            :key="'dt' + i"
          >
            <dt
              class="text-gray-300 text-sm"
            >
              {{ $t(`pages.visitImage.${meta.title}`) }}
            </dt>
            <dd
              v-if="meta.title === 'photographer'"
            >
              <div
                v-for="(photograph) in meta.value"
                :key="photograph.value"
              >
                <div
                  v-if="photograph.link"
                  :key="'linkdd' + i"
                >
                  <a
                    :href="photograph.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ photograph.value }}
                  </a>
                </div>
                <div
                  v-else
                  :key="'dd' + i"
                >
                  {{ photograph.value }}
                </div>
              </div>
            </dd>
            <dd
              v-else-if="meta.link"
            >
              <a
                :href="meta.link"
                target="_blank"
                rel="noopener noreferrer"
              >{{
                meta.value
              }}</a>
            </dd>
            <dd v-else>
              {{ meta.value }}
            </dd>
          </template>
        </dl>
      </div>
    </transition-group>
  </div>
</template>

<script>

export default {
  name: 'ImageMetaSecondary',

  props: {
    image: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      current: 0,
      direction: 1,
      transitionName: 'fade',
      show: false
    };
  },

  computed: {
    numberOfMetadata() {
      return this.metadataFiltered.length;
    },

    metadata() {
      const photographers={
        title: 'photographer',
        value: []
      };

      if (this.image.photographers?.length > 0) {
        this.image.photographers.forEach((photographer) => {
          const photograph = {
            value: photographer.name,
            link: photographer.link
          };
          photographers.value.push(photograph);
        });
      }

      return [
        { title: 'original_id', value: this.image.original_id, link: this.image.link },
        {
          title: 'georeferencer',
          value: this.image.georeferencer?.username === 'Anonymous volunteers' ? this.$t('pages.visitImage.anonymous_volunteer') : this.image.georeferencer
        },
        photographers.value.length > 0 ? photographers : {},
        { title: 'owner', value: this.image.owner?.name, link: this.image.owner?.link },
        { title: 'license', value: this.image.license }
      ];
    },

    metadataFiltered() {
      return this.metadata.filter(meta => meta.value);
    }
  },

  mounted() {
    this.show = true;
  },

  methods: {
    slide(dir) {
      this.direction = dir;
      dir === 1
        ? (this.transitionName = 'slide-next')
        : (this.transitionName = 'slide-prev');
      var len = this.metadata.length;
      this.current = (this.current + this.maxElPerSlide * (dir % len) + len) % len;
    }
  }
};
</script>

<style lang="postcss" scoped>
.slider_button {
  @apply not-sr-only absolute;
  top:50%;
  transform: translateY(-50%);

  &[disabled]{
    @apply sr-only;
  }

  &[disabled] svg {
    color: theme("colors.gray.100");
  }
  &:not([disabled]):hover svg {
    transform: scale(1.1);
    color: theme("colors.teal.300");
  }
}

.modeContribute .slider_button:not([disabled]):hover svg {
  transform: scale(1.1);
  color: theme("colors.orange.300");
}

#slider {
  min-height: var(--informationHeight);
  &:hover .slider_button[disabled] {
    @apply not-sr-only absolute;
  }
}

.scroll-container {
  overflow-y: auto;
}

dl {
  @apply flex flex-wrap items-start;
  display:grid;
  grid-template-columns: auto 1fr;
}

dt {
  @apply py-2 pr-4;
}

dd {
  @apply py-2 break-words;
  margin-top: -0.1rem;
}

.slide {
  backface-visibility: hidden;
  z-index: 1;
}

.slide-move {
  transition: all 600ms ease-in-out 50ms;
}

/* appearing */
.slide-next-enter-active,
.slide-prev-enter-active {
  transition: all 400ms ease-out;
}

/* disappearing */
.slide-next-leave-active,
.slide-prev-leave-active {
  transition: all 200ms ease-in;
  position: absolute;
  z-index: 0;
}

/* appear at / disappear to */
.slide-next-enter,
.slide-next-leave-to,
.slide-prev-enter,
.slide-prev-leave-to {
  opacity: 0;
}
</style>
